var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /app/~/stream-browserify/~/isarray/index.js
// module id = 78
// module chunks = 0